import { useQuery } from '@tanstack/react-query';
import { customerFactory } from 'v2/services/customer';

import type { ICardApiResponse } from 'v2/interfaces/customer';

import type { UseQueryOptions } from '@tanstack/react-query';

function useCardsListSubscriptions(options?: UseQueryOptions<ICardApiResponse[]>) {
  return useQuery(['paymentMethods', 'subscriptions'], () => customerFactory.getCardsListSubscriptionsRequest().toPromise(), options);
}

export { useCardsListSubscriptions };
